import axios from "axios";

import { BACKEND_URL } from "../constants"

const getTokensFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem("tokens") || "{}");
}

const updateTokensInLocalStorage = (access, refresh) => {
  const tokens = JSON.parse(localStorage.getItem("tokens") || "{}");
  tokens.access = access || tokens.access;
  tokens.refresh = refresh || tokens.refresh;
  return localStorage.setItem("tokens", JSON.stringify(tokens));
}

const clearTokensInLocalStorage = () => {
  localStorage.removeItem("tokens");
}

const isLoggedIn = () => {
  return Object.keys(getTokensFromLocalStorage()).length > 0;
}

const getTokenPair = (username, password, otpToken) => {
  const url = `${BACKEND_URL}/api/v1/auth/token/`;
  return axios.post(
    url,
    {
      username: username,
      password: password,
      otp_token: otpToken,
    },
  );
}

const refreshAccessToken = (refreshToken) => {
  const url = `${BACKEND_URL}/api/v1/auth/token/refresh/`;
  return axios.post(
    url,
    {
      refresh: refreshToken,
    },
  )
}

const getUser = () => {
  const url = `${BACKEND_URL}/api/v1/auth/user/`;
  return axios.get(url);
}

const changePassword = (currentPassword, newPassword) => {
  const url = `${BACKEND_URL}/api/v1/auth/user/password/`;
  return axios.post(
    url,
    {
      current_password: currentPassword,
      new_password: newPassword,
    },
  )
}

export const authServices = {
  getTokensFromLocalStorage,
  updateTokensInLocalStorage,
  clearTokensInLocalStorage,
  isLoggedIn,
  getTokenPair,
  refreshAccessToken,
  getUser,
  changePassword,
};